import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-product-campaign-builder',
  templateUrl: './product-campaign-builder.component.html',
  styleUrls: ['./product-campaign-builder.component.css']
})
export class ProductCampaignBuilderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
